'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNavbar = exports.Navbar = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _ = require('../../');

var _NavbarStyle = require('./Navbar.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Navbar = exports.Navbar = function Navbar(_ref) {
  var actions = _ref.actions,
      appSubtitle = _ref.appSubtitle,
      appTitle = _ref.appTitle,
      className = _ref.className,
      logoClick = _ref.logoClick,
      loginComponent = _ref.loginComponent,
      logoutComponent = _ref.logoutComponent,
      navbarContent = _ref.navbarContent,
      user = _ref.user,
      userOrgContent = _ref.userOrgContent;

  var userContent = user ? _react2.default.createElement(
    'div',
    { className: 'userInfo' },
    actions && _react2.default.createElement(
      'div',
      { className: 'item' },
      _react2.default.createElement(_.Dropdown, {
        trigger: _react2.default.createElement('i', { className: 'fa fa-gear' }),
        triggerLabel: 'Actions',
        items: actions })
    ),
    userOrgContent && _react2.default.createElement(
      'div',
      { className: 'item' },
      userOrgContent
    ),
    _react2.default.createElement(
      'div',
      { className: 'item noClick' },
      _react2.default.createElement('i', { className: 'g72-profile' }),
      user.name
    ),
    _react2.default.cloneElement(logoutComponent, {
      className: (className in logoutComponent.props ? logoutComponent.props.className : '') + ' item'
    })
  ) : _react2.default.createElement(
    'div',
    { className: 'right userInfo' },
    _react2.default.cloneElement(loginComponent, {
      className: (className in loginComponent.props ? loginComponent.props.className : '') + ' item'
    })
  );

  return _react2.default.createElement(
    'div',
    { className: 'navbarRow ' + className },
    _react2.default.createElement(
      'div',
      {
        className: 'item left col-xs-4 col-md-4',
        onClick: logoClick },
      _react2.default.createElement('i', { className: 'g72-swoosh' }),
      _react2.default.createElement(
        'div',
        { className: 'subItem' },
        _react2.default.createElement(
          'span',
          null,
          appTitle
        ),
        _react2.default.createElement(
          'span',
          null,
          appSubtitle
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'item col-xs-4 col-md-4' },
      navbarContent
    ),
    _react2.default.createElement(
      'div',
      { className: 'right col-xs-4 col-md-4' },
      userContent
    )
  );
};

Navbar.propTypes = {
  /**
   * List of nodes to be rendered. Optional.  If provided renders a navbar dropdown
   * labeled 'Actions' which contains a dropdown of the supplied
   */
  actions: _propTypes2.default.arrayOf(_propTypes2.default.node),
  /**
   * The Subtitle of your application
   */
  appSubtitle: _propTypes2.default.string,
  /**
   * The Title of your application
   */
  appTitle: _propTypes2.default.string,
  /**
   * The className provided by glamorous, it makes the magic happen.
   * Integral to the glamorous library, which this library is built upon.
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * This property is required to apply glamorous styles to the component.
   * It is not necessary to add a className, but it will be merged with the glamorous className if you do
   */
  logoClick: _propTypes2.default.func,
  /**
   * The component that will render when a user is logged in.
   * The default component is a ReactRouter link tag that routes to
   * /oauth/logout.  However, if that doesn't suit your needs, feel free to
   * provide a different component instead.
   */
  loginComponent: _propTypes2.default.node,
  /**
   * The component that will render when a user is logged out.
   * The default component is a ReactRouter link tag that routes to
   * /oauth/login.  However, if that doesn't suit your needs, feel free to
   * provide a different component instead.
   */
  logoutComponent: _propTypes2.default.node,
  /**
   * This is content rendered on an application to application basis.
   * Your app can pass a string or a node to this component to render static or
   * dynamic content based upon your application's needs.
   */
  navbarContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  /**
   * The user object is provided to the navbar to display information about the user,
   * as well as knowing whether to render a login/logout button.
   */
  user: _propTypes2.default.object,
  /**
   * Content for user organization
   */
  userOrgContent: _propTypes2.default.node
};

Navbar.defaultProps = {
  loginComponent: _react2.default.createElement(
    'a',
    { href: '/oauth/login' },
    'Login'
  ),
  logoutComponent: _react2.default.createElement(
    'a',
    { href: '/oauth/logout' },
    'Logout'
  ),
  userOrgContent: 'NSRL'
};

var StyledNavbar = exports.StyledNavbar = (0, _glamorous2.default)(Navbar)(_NavbarStyle.defaultStyle, _NavbarStyle.mapPropsAndThemeToStyle);

exports.default = StyledNavbar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Navbar/Navbar.js
// module id = 613
// module chunks = 0